import { makeStyles, Theme } from "@material-ui/core/styles";

const styles = makeStyles((theme: Theme) => {
  const border = '1px solid #cccccc';
  return {
    root: {
      height: 'auto',
    },
    title: {
      fontSize: 23,
      fontWeight: 'bold',
      textTransform: 'none',
    },
    subtitle: {
      fontSize: 17,
      fontWeight: 'bold',
      marginTop: 13,
      marginBottom: 10,
    },
    info: {
      color: 'grey',
      textTransform: 'none',
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    translationsContainer: {
      height: 300,
      width: '100%',
      overflowY: 'auto',
      marginTop: 13,
      border,
    },
    containerAppBar: {
      height: 40,
      width: '100%',
      backgroundColor: theme.palette.subMenusColor.main,
      verticalAlign: 'middle',
      position: 'relative',
    },
    containerTitle: {
      color: 'white',
      fontSize: 20,
      marginLeft: 10,
      paddingTop: 5,
    },
    holdingProfilesContainer: {
      width: '100%',
      border,
      height: 'auto',
      marginTop: 20,
    },
    translationItem: {
      paddingLeft: 40,
      color: 'grey',
      textTransform: 'none',
    },
    containerTitleButton: {
      position: 'absolute',
      right: 0,
      top: -5,
      color: 'white',
    },
    holdingProfilesContainerMenuItem: {
      width: '100%',
      border,
      height: 'auto',
      marginTop: 20,
    },
    addMore: {
      position: 'absolute',
      top: 2,
      right: 5,
      fontSize: 20,
    },
  };
});

export default styles;
